import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ba52630e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "StereoscopicSectionExamRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("请从下面4个选项中，选出 "), /*#__PURE__*/_createElementVNode("b", null, "无法"), /*#__PURE__*/_createTextVNode(" 通过一次性切割题目物体得到的剩余部分。")], -1));
const _hoisted_4 = {
  class: "bothCenter mt-1 mb-1"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bothCenter"
}, [/*#__PURE__*/_createElementVNode("span", null, "请选择：")], -1));
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $props.runtimeParams[$props.data.questionIndex].question,
    style: {
      "width": "300px"
    }
  }, null, 8, _hoisted_5)]), _hoisted_6, (_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    options: ['A', 'B', 'C', 'D'],
    onChoose: $options.onChoosed,
    key: `answerBtns${$props.data.questionIndex}`
  }, {
    default: _withCtx(btnIndex => [_createElementVNode("img", {
      src: $props.runtimeParams[$props.data.questionIndex].options[['A', 'B', 'C', 'D'][btnIndex.index]],
      class: "mb12",
      style: {
        "width": "220px"
      }
    }, null, 8, _hoisted_7)]),
    _: 1
  }, 8, ["onChoose"]))]);
}